module.exports = __webpack_public_path__ + "static/media/JAGLoFi.88747aa1.png";